import house1 from 'assets/images/house1.jpg'
import Icons from 'components/Icons';
import Seprator from 'components/Separator';
import './previewBlock.scss'

const PreviewBlock = ({ data }) => {
    return (
        <div className="content-preview">
            <img src={house1} alt="" />
            <div className='content'>
                <Seprator height={10} />
                <h1 className='title'>{data.title}</h1>
                <Seprator height={10} />
                <span className='desc'>{data.description}</span>
            </div>
            <div className="icon">
                <Icons.Globe3D />
            </div>
        </div>
    )
}


export default PreviewBlock;